import { useQuery } from '@tanstack/react-query';

import useGameDetails from './useGameDetails.js';


const defaultRoundDuration = 300;

function useRoundDuration() {
  const gameDetails = useGameDetails();

  const { data: roundDuration } = useQuery({
    queryKey: ['roundDuration', gameDetails.contracts.prediction?._address, gameDetails.wantedChain.id],
    queryFn: FetchRoundDuration,
    placeholderData: defaultRoundDuration,
    refetchInterval: 0, // do not refetch
    staleTime: 5 * 60 * 1000,
    cacheTime: 12 * 60 * 60 * 1000,
  });

  async function FetchRoundDuration() {
    if (!gameDetails.contracts.prediction)
      return defaultRoundDuration;
    const roundDuration = await gameDetails.contracts.prediction.methods.roundInterval().call();
    return roundDuration;
  }

  return roundDuration;
};

export default useRoundDuration;
